import { isRecord } from '@/utils/objects';

/**
 * The fields Data Pipelines appends to its user agent as a trailing JSON blob.
 * Every one is optional: older agents carry none of it, and the blob is
 * customer-adjacent data rather than a guaranteed contract.
 */
export type PipelinesUserAgent = {
  /** The user agent with the JSON blob removed. */
  pipelinesUserAgent: string;
  sourceName?: string;
  sourceId?: string;
  sourceType?: string;
  workspaceId?: string;
  userAgent?: string;
};

/** Splits the trailing JSON blob off the pipelines user agent. */
export function parsePipelinesUserAgent(ua: string | null | undefined): PipelinesUserAgent {
  const raw = ua ?? '';
  const braceIndex = raw.indexOf('{');
  let extra: Record<string, string> = {};
  if (braceIndex > -1) {
    try {
      const parsed: unknown = JSON.parse(raw.slice(braceIndex));
      if (isRecord(parsed)) {
        extra = Object.fromEntries(
          Object.entries(parsed)
            .filter(([, value]) => value != null)
            .map(([key, value]) => [key, String(value)]),
        );
      }
    } catch {
      extra = {};
    }
  }
  const pipelinesUserAgent = braceIndex > -1 ? raw.slice(0, braceIndex).trim() : raw;
  return { pipelinesUserAgent, ...extra };
}
